<template>
  <div class="c-register">
    <div class="c-register-form">
      <div class="c-register-form-banner" >
        <span>注 册</span>
      </div>
      <div>
        <div class="c-register-form-content" >
          <div class="c-register-form-content-upload" >
            <div class="left">
              <div class="left-info">
                <span>头像</span>
                <span>上传图像</span>
              </div>
              <div class="desc">图片大小500k以内的,格式jpg或png</div>
            </div>
            <div class="right">
              <a-upload
                name="file"
                list-type="picture"
                :action="uploadURL"
                :multiple="true"
                :before-upload="beforeUpload"
                @change="handleChange"
                :showUploadList="false"
              >
                <img :src="avatar1" v-if="avatar1" class="ant-avatar"/>
                <a-avatar :size="64" icon="user" v-else/>
              </a-upload>
            </div>
          </div>
          <a-form
            class="register-form"
            :form="form"
            labelAlign="left"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-form-item label="真实姓名">
              <a-input
                v-decorator="['trueName', { rules: [{ required: true, message: '请填写' }] }]"
                placeholder="不少于两位的中文字符"
                :maxLength="10"
              />
            </a-form-item>
            <a-form-item label="昵称">
              <a-input
                v-decorator="['nickName', { rules: [{ required: true, message: '请填写' }] }]"
                placeholder="不少于两位的中文字符"
                :maxLength="10"
              />
            </a-form-item>
            <a-form-item label="性别">
              <a-Select
                v-decorator="['gender', { rules: [{ required: true, message: '请填写' }] }]"
                placeholder="请选择"
                :options="genderOptions"
                :allowClear="true"
              />
            </a-form-item>
            <a-form-item label="手机号">
              <a-input
                v-decorator="['phoneNumber', { rules: [
                  { required: true, message: '请填写' },
                  {
                    validator: (rules, value, callback) => {
                      if (!/^1[3456789]\d{9}$/.test(value) && value) {
                        callback('手机号格式有误')
                      } else {
                        callback()
                      }
                    }
                  }
                ], validateTrigger: 'blur'}]"
                placeholder="请输入手机号"
                @blur="getVerifyPhone"
              >
                <div slot="addonAfter" @click="handleSendAuth" class="send">
                  {{phoneYszText}}
                </div>
              </a-input>
            </a-form-item>
            <a-form-item label="验证码">
              <a-input
                v-decorator="['phoneCode', { rules: [{ required: true, message: '请填写' }] }]"
                placeholder="请输入验证码"
                :maxLength="20"
              />
            </a-form-item>
           
            <a-form-item label="专业">
              <a-cascader
                v-decorator="['oneLevelMajor']"
                placeholder="请选择"
                :options="oneLevelMajorOptions"
                :allowClear="true"
              />
            </a-form-item>
            <a-form-item label="职业">
              <a-Select
                v-decorator="['occupation']"
                placeholder="请选择"
                :options="occupationOptions"
                :allowClear="true"
              />
            </a-form-item>
            <a-form-item label="邮箱">
              <a-input
                v-decorator="['mailbox',{ rules: [
                  { required: true, message: '请填写' },
                  {
                    validator: (rules, value, callback) => {
                      if (!/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+([a-zA-Z0-9_-])+/.test(value) && value) {
                        callback('邮箱格式有误')
                      } else {
                        callback()
                      }
                    }
                  }
                ], validateTrigger: 'blur'}]"
                placeholder="请输入邮箱"
                @blur="getVerifyEmail"
              />
            </a-form-item>
            <a-form-item label="学历">
              <a-Select
                v-decorator="['education']"
                placeholder="请选择"
                :options="educationOptions"
                :allowClear="true"
              />
            </a-form-item>
            <a-form-item label="毕业院校">
              <a-input
                v-decorator="['school']"
                placeholder="请输入毕业院校"
                :maxLength="60"
              />
            </a-form-item>
          </a-form>
        </div>
        <div class="c-register-form-checkbox">
          <a-checkbox @change="handleCheckbox"/>
          <div class="content">
            我已同意《 <span @click="handleAgreement">古农书平台用户注册协议</span> 》
          </div>
        </div>
        <div class="c-register-form-submit" @click="handleSubmit">
          注册
        </div>
      </div>
    </div>

    <Tips
      title="用户注册协议"
      :tipsVisible="tipsVisible"
      @handleClose="tipsVisible = false"
      :cont="agreementCont"
    />
  </div>
</template>

<script>
import { registerSelectList,sendAuth, register, verifyPhone, verifyEmail, getAgreement } from '@/api/user';
var regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+([a-zA-Z0-9_-])+/
var regPhone = /^1[3456789]\d{9}$/
import Tips from '@/components/Tips';
import Cookies from 'js-cookie'
import { setToken } from '@/utils/auth'

export default {
  components: {
    Tips
  },
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'register' }),
      genderOptions: [],
      oneLevelMajorOptions: [],
      occupationOptions: [],
      educationOptions: [],
      avatar: '',
      avatar1: '',
      checked: false,
      uploadURL: process.env.VUE_APP_BASE_API + 'reception/user/uploadImage',
      phoneYszText: '发送验证码',
      checkOne: false,
      verifyEmailFlag: true,
      verifyPhoneFlag: true,
      tipsVisible: false,
      agreementCont: ''
    };
  },

  created() {
    this.handleSelect();
  },

  methods: {
    /** 获取select框数据 */
    async handleSelect() {
      const r = await registerSelectList({});
      const { educationList, genderList, majorList, occupationList } = r.data
      this.genderOptions = genderList.map(item => {return {label: item.name, value: item.id}});
      this.educationOptions = educationList.map(item => {return {label: item.name, value: item.id}});
      this.oneLevelMajorOptions = majorList.map(item => {
        item.childrenClassifyList = item.childrenClassifyList.map(itm => {
          return {label: itm.name, value: itm.id}
        })
        return {label: item.name, value: item.id, children: item.childrenClassifyList}
      });
      this.occupationOptions = occupationList.map(item => {return {label: item.name, value: item.id}});
    },
    /** 上传头像 */
    handleChange(info) {
      if (info.file.status === 'done') {
        this.avatar1 = info.file.response.data.requestUrl
        this.avatar = info.file.response.data.databaseUrl
        this.$message.success(`${info.file.name}上传成功`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败`);
      }
    },

    /** checkbox */
    handleCheckbox(e) {
      this.checked = e.target.checked;
    },

    /** 获取验证码 */
    async handleSendAuth() {
      const phone = this.form.getFieldValue('phoneNumber')
      if (!phone) {
        return this.$message.warning('请先输入手机号码');
      } 
      if (!regPhone.test(phone)) {
        return this.$message.warning('您输入的手机号格式有误，请重新输入');
      }

      // 只能点击一次
      if (this.checkOne || this.phoneYszText != '发送验证码') {
        return
      }
      this.checkOne = true

      // 验证手机号是否重复
      const res = await verifyPhone({phone})
      if (res.data == 'true') {
        this.checkOne = false
        return this.$message.warning('您输入的手机已存在，请重新输入');
      }

      const ret = await sendAuth({phone});
      this.$message.success(ret.data);
      let sum = 60
      this.timer = setInterval(() => {
        if (sum <= 1) {
          clearInterval(this.timer)
          this.phoneYszText = '发送验证码'
          sum = 60

          return
        }
        sum = sum - 1
        this.phoneYszText = sum + '   s'

        this.checkOne = false
      }, 1000)
    },

    /**
     * 验证手机号是否已存在
     */
    async getVerifyPhone() {
      const phone = this.form.getFieldValue('phoneNumber');
      if (phone) {
        const res = await verifyPhone({phone})
        if (res.data === 'true') {
          this.verifyPhoneFlag = false
          this.$message.error('该手机号已存在')
        } else {
          this.verifyPhoneFlag = true
        }
      }
    },


    /**
     * 验证邮箱是否存在
     */
    async getVerifyEmail() {
      const value = this.form.getFieldValue('mailbox')
      if (value) {
        const res = await verifyEmail({
          email: value
        })
        if (res.data === 'true') {
          this.verifyEmailFlag = false
          this.$message.error('该邮箱已存在')
        } else {
          this.verifyEmailFlag = true
        }
      }
    },

    /** 提交 */
    handleSubmit() {
      if (!this.checked) {
        this.$message.warning('请先勾选古农书平台用户注册协议');
      } else if (!this.verifyPhoneFlag) {
        this.$message.error('手机号已存在')
      } else if (!this.verifyEmailFlag) {
        this.$message.error('邮箱已存在')
      } else {
        this.form.validateFields(async (err, values) => {
          console.log(err, values);
          if (err) {
            console.log('Received values of form: ', values);
          } else {
            try {
              // 参数处理
              let params = {...values, avatarUrl: this.avatar}

              if (values.oneLevelMajor && values.oneLevelMajor.length == 1) {
                params.oneLevelMajor = values.oneLevelMajor[0]
              }

              if (values.oneLevelMajor && values.oneLevelMajor.length == 2) {
                params.oneLevelMajor = values.oneLevelMajor[0]
                params.twoLevelMajor = values.oneLevelMajor[1]
              }

              const res = await register(params);

              // 登录成功后的处理
              setToken(res.data.WXTOKEN)
              localStorage.setItem('userInfo', JSON.stringify(res.data.userinfo))
              Cookies.set('usertype', res.data.usertype)
              Cookies.set('userTypeAll', res.data.usertype == 1 ? res.data.usertype : '1,2')
              Cookies.set('phoneNumber', res.data.userinfo.phoneNumber)
              Cookies.set('userid', res.data.userinfo.userId)
              this.$message.success('注册成功');
              this.$router.push('/')
            } catch (error) {
              console.log('error', error)
            }
          }
        });
      }
    },

    // 图片上传格式
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('格式不正确!');
      }
      const isLt2M =(file.size / 1000) < 500;
      if (!isLt2M) {
        this.$message.error('建议在500KB以内!');
      }
      return isJpgOrPng && isLt2M;
    },

    // 用户协议
    async handleAgreement() {
      this.tipsVisible = true
      const res = await getAgreement()

      res.data.map(item => {
        if (item.aboutType == 4) {
          this.agreementCont = item.aboutContent
        }
      })
    }
  }
}


</script>
<style lang="less">
.c-register {
  width: 100%;
  height: auto;
  background: #FEF6EA;
  padding: 50px 0;

  &-form {
    width: 1200px;
    background: #FFFFFF;
    border-radius: 6px;
    margin: 0 auto;
    padding-bottom: 40px;

    &-banner {
      width: 1200px;
      height: 200px;
      background: #000000;
      border-radius: 6px;
      background: url(../../assets/register.png) no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
      }
    }

    &-content {
      padding:  30px 380px 30px 460px;
      .ant-form-item {
        width: 380px;
        height: 51px;
        background: #FFFFFF;
        margin: 0;
        input {
          height: 50px;
          border: none;
          box-shadow: none;
          outline: none;
          border-radius: 0 !important ;
          :focus {
            box-shadow: none !important;
          }
        }

        input:hover {
          border-color: #ECE0CE !important;
        }

        .ant-form-item-label {
          width: 80px;
          line-height: 50px;
        }

        .ant-select {
          .ant-select-selection {
            border: none;
            box-shadow: none;
            outline: none;
            border-radius: 0;
          }
        }

        .ant-select-arrow {
          color: #000000;
        }

        .ant-form-item-label {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
        }
      }

      .has-error .ant-input:focus {
        box-shadow: none !important;
        border-color: #ECE0CE;;
      }

      .has-error .ant-input:hover {
        border-color: #ECE0CE !important;
      }

      &-upload{
        width: 380px;
        height: 81px;
        background: #FFFFFF;
        border-bottom: 1px solid #ECE0CE;;
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .left {
          width: 250px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: flex-start;

          &-info {
            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }

            :nth-child(1) {
              color: #000000;
            }

            :nth-child(2) {
              color: #CBAB7A;
              margin-left: 20px;
            }
          }

          .desc {
            text-align: left;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #e1e1e1;
          }
        }

        .ant-avatar {
          width: 60px;
          height: 60px;
          background: #CBAB7A;
          cursor: pointer;
        } 
      }

      .ant-input-group-addon {
        border-radius: 0;
        background-color: #fff;
        border: none;
        cursor: pointer;
        color: #947243 !important;
      }
    }

    &-checkbox {
      padding:  0 0 0 460px;
      display: flex;
      align-items: center;

      .content {
        margin-left: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        span {
          color: #CBAB7A;
          cursor: pointer;
        }
      }

      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #CBAB7A;
        border-color: #CBAB7A;
      }
    }

    &-submit {
      margin: 30px 0 0 460px;
      width: 380px;
      height: 50px;
      background: #CBAB7A;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      cursor: pointer;
    }
  }

  .has-error {
    position: relative;
  }
  .ant-form-explain {
    position: absolute;
    bottom: -18px;
    left: 0px;
    z-index: 10;
  }

  .ant-cascader-picker-arrow {
    color: #000000;
  }
  .ant-cascader-picker-label {
    text-align: left;
  }
}
.c-register .ant-form {
  padding: 0;
}
.register-form .ant-input-group-wrapper {
  top: 0!important;
}

.register-form .ant-form-item-control {
  line-height: 48px;
}
// .c-register .ant-form-item {
//   border-bottom: none;
// }
</style> 